import fieldByPart from "../data/generated/fieldByPart.json";

export function splitRequiredFromField(name: string): {
  required_type: requireType;
  field: string;
} {
  const [type, field] = name.split(/_(.*)/s); // Split on first underscore;

  return { required_type: type as requireType, field };
}

export function mergeCalculationQueue(existing: string[], focus: string[]) {
  const subResultList = [];
  for (const element of focus) {
    let index = existing.indexOf(element);

    if (index > -1) {
      // element is already existiting
      existing.splice(index, 0, ...subResultList);
      subResultList.length = 0;
    } else {
      subResultList.push(element);
    }
  }
  existing.push(...subResultList);

  return existing;
}

export function groupByElement(queue: string[]): Record<string, string[]> {
  const byElement = queue.reduce((result, child) => {
    const [element_id, field_name] = child.split("|");
    if (!result.hasOwnProperty(element_id)) {
      result[element_id] = [];
    }

    result[element_id].push(field_name);
    return result;
  }, {});

  return byElement;
}
